export function waitForNextEventLoop() {
  return new Promise<void>((resolve) => setTimeout(resolve, 0))
}
